import * as React from 'react';
import clsx from 'clsx';

export enum IconType {
  Success = "success",
  Error = "error",
  Empty = "empty"
}

interface FlowOutcomeProps {
  title: string;
  textLight?: boolean;
  icon?: IconType;
  description?: string;
}

export default function FlowOutcome(props: FlowOutcomeProps) {
  const title = props.title;
  const description = props.description;
  const titleClasses = clsx(
    "text-2xl font-semibold text-center font-ginto-nord-md",
    {
      "text-black": !props.textLight,
      "text-charcoal-25": props.textLight
    }
  );

  const descriptionClasses = clsx(
    "text-md text-center",
    {
      "text-charcoal-50": !props.textLight,
      "text-charcoal-25": props.textLight
    }
  );

  const icon_image = () => {
    switch (props.icon) {
      case IconType.Success:
        return "https://storage.googleapis.com/cartwheel-assets/check-mark.svg";
      case IconType.Error:
        return "https://storage.googleapis.com/cartwheel-assets/error_flag.svg";
      case IconType.Empty:
        return "https://storage.googleapis.com/cartwheel-assets/empty_state.svg";
      default:
        return undefined;
    }
  };

  return (
    <div className="w-full bg-white gap-y-8 pt-16 pb-8 flex flex-col items-center justify-center text-wrap">
      {icon_image() && (
        <img
          src={icon_image()}
          alt="Outcome Icon"
          className="w-1/2 h-20"
        />
      )}
      <h2 className={titleClasses}>
        {title}
      </h2>
      {description && (<p
        className={descriptionClasses}
        dangerouslySetInnerHTML={{__html: description }} >
      </p>)}
    </div>
  );
}
